import { api } from '../../Api';
import UrlBuilder from '../../url/UrlBulder';
import ICollectionParams from '../../../models/params/ICollectionParams';
import { ICollectionResponse } from '../../../models/responces/ICollectionResponse';
import { sendAxiosRequest } from '../../utils/sendRequest';

export interface ICRUDDeleteParams {
  dataObjectName: string;
  ids: number[];
  collectionParams?: ICollectionParams;
}
const apiDelete = (params: ICRUDDeleteParams) =>
  sendAxiosRequest({
    method: 'delete',
    headers: { Authorization: api.getToken() },
    url: UrlBuilder.getURL({
      handler: 'crud',
      dataObjectName: params.dataObjectName,
      id: params.ids.join(','),
      collectionParams: params.collectionParams || undefined
    }),
    responseType: 'json'
  }).then(resp => resp.data) as Promise<ICollectionResponse>;
export default apiDelete;
